const apiUrl = process.env.REACT_APP_API_URL;
export const GetEscoles = async ( page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/escoles`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
